import React from 'react';
import PropTypes from 'prop-types';
import {
  FormLabel, Select, MenuItem, FormControl,
} from '@mui/material';
import toPairs from 'lodash/toPairs';

import { RepairTicketStatuses } from '../../lib/utils';

const styles = {
  formLabel: {
    textAlign: 'center',
    width: '100%',
  },
};

class RepairTicketStatusSelect extends React.Component {
  constructor(props) {
    super(props);
    const { value } = props;

    this.state = {
      selectedStatus: value,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const { handleChange } = this.props;
    const stateUpdate = { [event.target.name]: event.target.value };
    this.setState(stateUpdate);

    handleChange(event.target.value);
  }

  render() {
    const { showAll, disabled } = this.props;
    const { selectedStatus } = this.state;

    return (
      <FormControl
        component="fieldset"
        style={{ width: '100%' }}
      >
        <FormLabel
          component="legend"
          style={styles.formLabel}
        >
          Status
        </FormLabel>
        <Select
          displayEmpty
          disabled={disabled}
          style={{ width: '100%' }}
          onChange={this.handleChange}
          value={selectedStatus}
          variant="standard"
          inputProps={{
            name: 'selectedStatus',
            id: 'repair-ticket-status-picker',
          }}
        >
          {showAll && (
            <MenuItem
              value=""
              key="none"
            >
              All
            </MenuItem>
          )}
          {RepairTicketStatuses
            && toPairs(RepairTicketStatuses).map(([key, name]) => (
              <MenuItem
                value={name}
                key={key}
              >
                {name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  }
}
RepairTicketStatusSelect.defaultProps = {
  value: '',
  disabled: false,
  showAll: true,
};
RepairTicketStatusSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  showAll: PropTypes.bool,
};

export default RepairTicketStatusSelect;
